import type { MailboxInfo } from 'owa-client-types';

const map = new WeakMap<Window, MailboxInfo>();

export function setWindowMailboxInfo(targetWindow: Window, mailboxInfo: MailboxInfo): void {
    map.set(targetWindow.top ?? targetWindow, mailboxInfo);
}

export function deleteWindowMailboxInfo(targetWindow: Window): void {
    map.delete(targetWindow.top ?? targetWindow);
}

export function getPopoutWindowMailboxInfo(targetWindow: Window): MailboxInfo | undefined {
    return map.get(targetWindow.top ?? targetWindow);
}
